import { render, staticRenderFns } from "./CustomCalculation.vue?vue&type=template&id=bfe3f620&scoped=true"
import script from "./CustomCalculation.vue?vue&type=script&lang=ts"
export * from "./CustomCalculation.vue?vue&type=script&lang=ts"
import style0 from "./CustomCalculation.vue?vue&type=style&index=0&id=bfe3f620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe3f620",
  null
  
)

export default component.exports